import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { FloatLabel } from '../../Components';
import { ERdvService } from '../../Services/ERdvService';
import Modal, { setAppElement } from 'react-modal';
import { ErdvErrors, ErdvErrorsEnum } from '../../Models/Enum/ErdvErrors';

interface IERdvDatasWidgetProps {
    dictTitleLabel: string;
    dictNameLabel: string;
    dictSurnameLabel: string;
    dictNissLabel: string;
    dictPostCodeLabel: string;
    dictPhoneLabel: string;
    dictMailLabel: string;
    dictDatasTitle: string;
    dictNissHelp: string;
    dictMailHelp: string;
    dictTitleMr: string;
    dictTitleMrs: string;
    dictTitleMs: string;
    dictDateOfBirthLabel: string;
    dictTitleTip1: string;
    dictTitleTip2: string;
    dictDescTip1: string;
    dictDescTip2: string;

    date: Date;
    hoursStart: string;
    hoursEnd: string;
    codeService: string;
    codeSite: string;
    ressource: { id: number; key: string; type: string };
    code: number;
    visitorUID: string;

    agency: string;
    service: string;
    justification: string;
    timing: string;

    isNissMandatory: boolean;

    user: {
        civilite: number;
        niss: string;
        nom: string;
        prenom: string;
        telephone: string;
        mail: string;
    };
    showValidateButton: (val: boolean) => void;
    setDatas: (datas: {
        title: number;
        name: string;
        surname: string;
        niss: string;
        mail: string;
        phone: string;
    }) => void;
    handleNavTo: (val: number, error?: ErdvErrors) => void;
}

interface IERdvDatasWidgetState {
    title: number | null;
    name: string | null;
    surname: string | null;
    niss: string | null;
    mail: string | null;
    phone: string | null;
    lastKeyPressed: number | null;
    modalIsOpen: boolean;
}

export class ERdvDatasWidget extends Component<
    IERdvDatasWidgetProps,
    IERdvDatasWidgetState
> {
    constructor(props: IERdvDatasWidgetProps) {
        super(props);

        void ERdvService.lockTimeArea(
            this.props.date,
            this.props.hoursStart,
            this.props.hoursEnd,
            this.props.codeService,
            this.props.codeSite,
            this.props.ressource,
            this.props.code,
            this.props.visitorUID
        ).then((result: any) => {
            if (!result || !result.locked) {
                var error = {
                    value: ErdvErrorsEnum.LockTimeError,
                    guid: result.errorGuid
                } as ErdvErrors;
                this.props.handleNavTo(1, error);
            }
        });

        this.state = {
            title: this.props.user ? this.props.user.civilite : null,
            name: this.props.user ? this.props.user.nom : null,
            surname: this.props.user ? this.props.user.prenom : null,
            niss: this.props.user ? this.props.user.niss : null,
            mail: this.props.user ? this.props.user.mail : null,
            phone: this.props.user ? this.props.user.telephone : null,
            lastKeyPressed: 0,
            modalIsOpen: false,
        };

        this.props.showValidateButton(false);

        if (this.props.user) {
            this.props.showValidateButton(this.isAllCompleted());
        }
    }

    floatLabelActive(selectedValue: string | null): boolean {
        return selectedValue && selectedValue !== null ? true : false;
    }

    isMailOk = () => {
        if (this.state.mail) {
            return !!this.state.mail.match(
                // eslint-disable-next-line no-control-regex
                /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
            );
        } else {
            return false;
        }
    };

    openModal = () => {
        this.setState({ modalIsOpen: true });
    };

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    };

    handleChangeNiss = (event: React.ChangeEvent<HTMLInputElement>) => {
        let val = event.target.value;
        val = val.replace(/\D/g, '');

        if (val.length === 0) {
            event.preventDefault();
        }

        if (val.length === 7) {
            val = val.substring(0, 6) + '-' + val.slice(-1);
        } else if (val.length === 10) {
            val =
                val.substring(0, 6) +
                '-' +
                val.substring(6, 9) +
                '.' +
                val.slice(-1);
        } else if (val.length > 7 && val.length < 10) {
            val = val.substring(0, 6) + '-' + val.substring(6, 9);
        } else if (val.length > 10) {
            val =
                val.substring(0, 6) +
                '-' +
                val.substring(6, 9) +
                '.' +
                val.substring(9, 11);
        }

        this.setState({ niss: val }, this.pushDataToForm);
    };

    handleChangePhone = (event: React.ChangeEvent<HTMLInputElement>) => {
        let val = event.target.value;

        if (this.props.isNissMandatory) {
            if (!val.match(/\+32?[0-9]+/)) {
                if (val.match(/\+3/)) {
                    val = '';
                } else {
                    val = '+32' + val;
                }
            }

            if (val.length > 12) {
                val = val.substring(0, 12);
            }
        }

        this.setState({ phone: val }, this.pushDataToForm);
    };

    handleKeyDownNumber = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === 17) {
            this.setState({ lastKeyPressed: 17 });
        } else if (event.keyCode === 86 && this.state.lastKeyPressed === 17) {
            this.setState({ lastKeyPressed: null });
        } else if (event.keyCode === 67 && this.state.lastKeyPressed === 17) {
            this.setState({ lastKeyPressed: null });
        } else if (event.keyCode === 65 && this.state.lastKeyPressed === 17) {
            this.setState({ lastKeyPressed: null });
        } else if (
            !event.key.match(/[0-9]/) &&
            // SUPPR
            event.keyCode !== 8 &&
            // DELETE
            event.keyCode !== 46 &&
            // haut bas droite gauche
            event.keyCode !== 37 &&
            event.keyCode !== 38 &&
            event.keyCode !== 39 &&
            event.keyCode !== 40 &&
            // END & HOME
            event.keyCode !== 35 &&
            event.keyCode !== 36 &&
            // TAB
            event.keyCode !== 9
        ) {
            this.setState({ lastKeyPressed: null });
            event.preventDefault();
        }
    };

    handleChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        switch (event.target.name) {
            case 'title':
                this.setState(
                    { title: +event.target.value },
                    this.pushDataToForm
                );
                break;

            case 'name':
                this.setState(
                    { name: event.target.value },
                    this.pushDataToForm
                );
                break;

            case 'surname':
                this.setState(
                    { surname: event.target.value },
                    this.pushDataToForm
                );
                break;

            case 'phone':
                this.setState(
                    { phone: event.target.value },
                    this.pushDataToForm
                );
                break;

            case 'mail':
                this.setState(
                    { mail: event.target.value },
                    this.pushDataToForm
                );
                break;

            default:
                break;
        }
    };

    pushDataToForm = () => {
        this.props.setDatas({
            title: this.state.title ?? 0,
            name: this.state.name ?? '',
            surname: this.state.surname ?? '',
            niss: this.state.niss ?? '',
            mail: this.state.mail ?? '',
            phone: this.state.phone ?? '',
        });

        this.props.showValidateButton(this.isAllCompleted());
    };

    isAllCompleted = () => {
        return (
            !!this.state.name &&
            !!this.state.surname &&
            (!this.props.isNissMandatory ||
                (!!this.state.niss && this.state.niss.length === 13)) &&
            !!this.state.phone &&
            (this.state.title === 0 || this.state.title === 1) &&
            this.isMailOk()
        );
    };

    componentDidMount() {
        setAppElement('body');
    }

    render() {
        const modalStyle = {
            content: {
                maxWidth: '600px',
                height: 'fit-content',
                margin: 'auto',
                paddingBottom: '24px',
            },
        };

        return (
            <div className="container">
                <div className="row">
                    <div className="offset-md-2 col-md-8">
                        <h2 className="h2">{this.props.dictDatasTitle}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="offset-md-2 col-md-6">
                        <div className="row">
                            <div className="col-3">
                                <FloatLabel
                                    active={
                                        this.state.title === 0 ||
                                        this.state.title === 1
                                    }
                                    label={this.props.dictTitleLabel}
                                    labelId={'title'}
                                >
                                    <select
                                        name="title"
                                        onChange={this.handleChange}
                                    >
                                        <option disabled selected hidden>
                                            {' '}
                                        </option>
                                        <option
                                            selected={
                                                this.state.title === 0 &&
                                                this.state.title !== null
                                            }
                                            value="0"
                                        >
                                            {this.props.dictTitleMr}
                                        </option>
                                        <option
                                            selected={this.state.title === 1}
                                            value="1"
                                        >
                                            {this.props.dictTitleMrs}
                                        </option>
                                    </select>
                                </FloatLabel>
                            </div>
                            <div className="col-5">
                                <FloatLabel
                                    active={this.floatLabelActive(
                                        this.state.name
                                    )}
                                    label={this.props.dictNameLabel}
                                    labelId={'name'}
                                >
                                    <input
                                        name="name"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.name ?? ''}
                                    />
                                </FloatLabel>
                            </div>
                            <div className="col-4">
                                <FloatLabel
                                    active={this.floatLabelActive(
                                        this.state.surname
                                    )}
                                    label={this.props.dictSurnameLabel}
                                    labelId={'surname'}
                                >
                                    <input
                                        name="surname"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.surname ?? ''}
                                    />
                                </FloatLabel>
                            </div>
                        </div>
                        <div className="row mb-n4">
                            <div className="col-12">
                                <FloatLabel
                                    active={this.floatLabelActive(
                                        this.state.niss
                                    )}
                                    label={this.props.dictNissLabel}
                                    labelId={'niss'}
                                >
                                    <input
                                        name="niss"
                                        type="text"
                                        value={this.state.niss ?? ''}
                                        onChange={this.handleChangeNiss}
                                        onKeyDown={this.handleKeyDownNumber}
                                    />
                                </FloatLabel>
                                <button
                                    className="btn-link btn-no-look p-0 mt-n3"
                                    style={
                                        {
                                            fontFamily: 'Roboto',
                                        } as React.CSSProperties
                                    }
                                    onClick={this.openModal}
                                >
                                    <i className="icon-interrogation"></i>
                                    {this.props.dictNissHelp}
                                </button>
                                <Modal
                                    isOpen={this.state.modalIsOpen}
                                    onRequestClose={this.closeModal}
                                    contentLabel="Example Modal"
                                    style={modalStyle}
                                >
                                    <div
                                        className="container"
                                        onClick={this.closeModal}
                                    >
                                        <div className="row">
                                            <div className="col-12">
                                                <h2 className="m-3">
                                                    <i className="icon-interrogation"></i>
                                                    Tip
                                                </h2>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <h3 className="m-0">
                                                    {this.props.dictTitleTip1}
                                                </h3>
                                                <p>{this.props.dictDescTip1}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    alt="imgTip1"
                                                    src="/Images/tipniss1.jpg"
                                                    className="w-100"
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-md-6">
                                                <h3 className="m-0">
                                                    {this.props.dictTitleTip2}
                                                </h3>
                                                <p>{this.props.dictDescTip2}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    alt="imgTip2"
                                                    src="/Images/tipniss2.jpg"
                                                    className="w-100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <FloatLabel
                                    active={this.floatLabelActive(
                                        this.state.phone
                                    )}
                                    label={this.props.dictPhoneLabel}
                                    labelId={'phone'}
                                >
                                    <input
                                        name="phone"
                                        type="text"
                                        value={this.state.phone ?? ''}
                                        onChange={this.handleChangePhone}
                                        onKeyDown={this.handleKeyDownNumber}
                                    />
                                </FloatLabel>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <FloatLabel
                                    active={this.floatLabelActive(
                                        this.state.mail
                                    )}
                                    label={this.props.dictMailLabel}
                                    labelId={'mail'}
                                >
                                    <input
                                        name="mail"
                                        type="text"
                                        onChange={this.handleChange}
                                        value={this.state.mail ?? ''}
                                    />
                                </FloatLabel>
                                <label>{this.props.dictMailHelp}</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 mt-5 py-5 mb-0 contact-theme-container">
                        <div className="row">
                            <div className="col-2 text-center">
                                <i className="icon-place"></i>
                            </div>
                            <div className="col-10">{this.props.agency}</div>
                        </div>
                        <div className="row">
                            <div className="col-2 text-center">
                                <i className="icon-user"></i>
                            </div>
                            <div className="col-10">
                                {this.props.service} <br />
                                {this.props.service.localeCompare(
                                    this.props.justification
                                ) === -1 && (
                                    <span>{this.props.justification}</span>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 text-center">
                                <i className="icon-calendar"></i>
                            </div>
                            <div className="col-10">{this.props.timing}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

WidgetHelper.register(ERdvDatasWidget, 'erdv-datas-widget');
